import { graphql } from 'react-relay';

import { CodepushVersionWindowPaginator_query$key } from '../../../relay/__generated__/CodepushVersionWindowPaginator_query.graphql';
import FragmentWindowPaginator, { FragmentWindowPaginatorProps } from '../../core/FragmentWindowPaginator';
import Pagination from '../../page/Pagination';

const CodepushVersionWindowPaginator_query = graphql`
  fragment CodepushVersionWindowPaginator_query on Query
  @argumentDefinitions(
    filters: { type: CodepushVersionFilter }
    page: { type: Int, defaultValue: 1 }
    pageSize: { type: Int, defaultValue: 20 }
  )
  @refetchable(queryName: "CodepushVersionWindowPaginatorRefreshQuery") {
    codepushVersions(filters: $filters, page: $page, pageSize: $pageSize) {
      totalCount
      pages {
        ...Pagination_pages
      }
      edges {
        node {
          id
        }
      }
      ...CodepushVersionConnectionDataTable_codepushVersionConnection
    }
  }
`;

type Props = {} & Omit<FragmentWindowPaginatorProps<CodepushVersionWindowPaginator_query$key>, 'fragment'>;

const CodePushVersionWindowPaginator = ({ ...props }: Props) => (
  <FragmentWindowPaginator fragment={CodepushVersionWindowPaginator_query} {...props}>
    {(data, { loadPage }) =>
      props.children(data, {
        loadPage,
        renderPagination: (props) => <Pagination {...props} pages={data.codepushVersions.pages} loadPage={loadPage} />,
      })
    }
  </FragmentWindowPaginator>
);

export default CodePushVersionWindowPaginator;
